/**
 * @generated SignedSource<<711180ccf51b771573a7257f3074d406>>
 * @relayHash 633f8580ff29ac0eef5aabbd01aa2025
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 04b103c3fd8e6dd3187db1fe66459b8fdab4878d85ace24413ec2d1f946efb9f

import type { ConcreteRequest } from 'relay-runtime';
export type EditorFlagsUserPersonalInformationQuery$variables = {
  accountId: string;
};
export type EditorFlagsUserPersonalInformationQuery$data = {
  readonly user: {
    readonly displayName: string | null;
    readonly id: string | null;
  } | null;
};
export type EditorFlagsUserPersonalInformationQuery = {
  response: EditorFlagsUserPersonalInformationQuery$data;
  variables: EditorFlagsUserPersonalInformationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "accountId"
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "displayName"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EditorFlagsUserPersonalInformationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorFlagsUserPersonalInformationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "633f8580ff29ac0eef5aabbd01aa2025",
    "id": "04b103c3fd8e6dd3187db1fe66459b8fdab4878d85ace24413ec2d1f946efb9f",
    "metadata": {},
    "name": "EditorFlagsUserPersonalInformationQuery",
    "operationKind": "query",
    "text": "query EditorFlagsUserPersonalInformationQuery($accountId:ID!){user:confluence_atlassianUser(id:$accountId){id,displayName}}"
  }
};
})();

(node as any).hash = "f3c3315775439f1cc7912f906f070deb";

export default node;
